import Base from './base'
import Vue from 'vue'

class Config extends Base {
  constructor () {
    super('Config')
  }

  async get (types) {
    try {
      Vue._logger.debugger(Vue._config.api.login)
      const result = await Vue.axios.get(Vue._config.api.systemConfig, { params: { name: types } })
      if (result.data.code === 1) {
        return result.data
      } else {
        throw new Error('获取配置信息失败')
      }
    } catch (e) {
      throw e
    }
  }
}

export default new Config()
